import { render, staticRenderFns } from "./CustomerBehaviorChart.vue?vue&type=template&id=b1701894&scoped=true&"
import script from "./CustomerBehaviorChart.vue?vue&type=script&lang=js&"
export * from "./CustomerBehaviorChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBehaviorChart.vue?vue&type=style&index=0&id=b1701894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1701894",
  null
  
)

export default component.exports